export default {
  edi: {
    title: "EDI",
    profile: "Profile",
    profile_name: "Profile Name",
    im: "Import",
    ex: "Export",
    entity: "Entity Name",
    type: "EDI Type",
    table: 'Table',
    import_type: 'Import Type',
    import_profile: 'Import using pre-defined profiles',
    import_table: 'Import directly to tables',
    column: 'Column',
    db_title: 'Database Table Columns',
    csv_title: 'CSV Columns',
    submit: 'Start Upload',
    close: 'OK',
    columnData: 'Data for column',
    chooseColumn: 'Choose a column',
    selected: 'Selected',
    select: 'Select',
    selectColumn: 'Please choose a column',
    primary_key: 'Primary Keys',
    primary_key_tips: 'Enter primary column names here. They are NOT the Primary column in database but the columns are used to check duplicate data. Separate by comma ",". For example: email,phone',
    column_mapping: 'Columns mapping',
    update_conditions: 'Update Conditions',
    update_conditions_tips: 'Enter update conditions here (if any). Separate by comma ",". Each condition must be in valid SQL syntax. For example: email!=\'example@gmail.com\',phone=\'6663629\'',
    select_profile: 'Select Profile',
    select_table: 'Select Table',
    select_file: 'Upload File and Match Columns',
    start_upload: 'Start Upload Data',
    file_path: 'File Path',
    file_path_tips: 'Enter absolute path to the file. For example: /home/gru/uploads/user.csv',
    upload: 'Upload Sample CSV',
    upload_again: 'Upload New Sample CSV',
    download: 'Download Sample CSV',
    result: {
      success: 'Import result: Inserted {inserted} item(s), Updated: {updated} item(s)!',
      failure: 'Import Failed!',
      missing_keys: 'Import Failed! Missing required KEY column values!',
      wrong_key: 'Import Failed! One or more primary keys are not existed in database table columns.',
      invalid_syntax: 'Import Failed! The update conditions or columns mapping is INVALID!'
    },
    file: {
      select: 'Please select a file',
      tryAgain: 'Choose another file',
      withHeaders: 'This file includes headers',
      withoutHeaders: 'This file does not include headers',
    },
    error: {
      title: 'Error',
      columnNumber: 'You do not have enough columns. <br><b>Required columns are</b>: ',
      missingColumns: 'Missing required columns:',
      selectColumn: 'You need to select all columns',
      fileNumber: 'You need to select a file',
      fileSelection: 'No file has been selected',
      invalidFile: 'This file is invalid. Try to use a CSV or Xlsx file',
      noWorksheet: 'Must have at least one worksheet',
      emptyWorksheet: 'The worksheet is empty',
    }

  }
};
